// Shell UI state (drawer open) shared by the top bar and the drawer.
import { createContext, useContext } from 'react';

export const ShellCtx = createContext<{ navOpen: boolean; setNavOpen: (v: boolean) => void }>({ navOpen: false, setNavOpen: () => {} });
export const useShell = () => useContext(ShellCtx);
